// extracted by mini-css-extract-plugin
export default {"wrapper":"_s-z","response":"at-z","error":"bt-z","disabled":"ct-z","buttons":"dt-z","feedbackQuestionSection":"et-z","yesNoWrapper":"ft-z"};